/*
 * Client names as styled text wordmarks (no logo files), coloured and set to
 * read like the mockup's logos (00.24.07). The small marks beside them are
 * generic shapes (chevrons, a shield, dots, crosses), not copies of the real
 * logos. Each mark exposes the plain organisation name to assistive tech and
 * hides the decorative styling.
 */
import './ClientMarks.css';

export function AgilusMark() {
  return (
    <p className="cmark cmark--agilus">
      <span className="sr-only">agilus diagnostics</span>
      <span aria-hidden="true" className="cmark__agilus-wrap">
        <span className="cmark__agilus">
          agilus
          <span className="cmark__chev">
            <i />
            <i />
            <i />
          </span>
        </span>
        <span className="cmark__agilus-sub">diagnostics</span>
      </span>
    </p>
  );
}

export function MaxLabMark() {
  return (
    <p className="cmark cmark--max">
      <span className="sr-only">MAX Lab</span>
      <span aria-hidden="true">
        <svg className="cmark__shield" viewBox="0 0 24 28" aria-hidden="true" focusable="false">
          <path d="M1 1h22v15c0 6-6 9.5-11 11C7 25.5 1 22 1 16Z" fill="#0d1f5c" />
          <path
            d="M12 6.5l1.4 3.4 3.6-.6-2.2 2.9 2.2 2.9-3.6-.6L12 18l-1.4-3.5-3.6.6 2.2-2.9L7 9.3l3.6.6Z"
            fill="#5fd4ff"
          />
        </svg>
        <b>MAX</b> Lab
      </span>
    </p>
  );
}

export function SpadiaMark() {
  return (
    <p className="cmark cmark--spadia">
      <span className="sr-only">SPADIA</span>
      <span aria-hidden="true">
        <span className="cmark__dots">
          <i />
          <i />
          <i />
          <i />
          <i />
          <i />
        </span>
        SPADIA
      </span>
    </p>
  );
}

export const CLIENT_LOGOS = [
  { key: 'medibuddy', name: 'MediBuddy' },
  { key: 'pathkind', name: 'Pathkind Labs' },
  { key: 'oncquest', name: 'Oncquest Laboratories' },
  { key: 'drlal', name: 'Dr. B. Lal Clinical Laboratory' },
  { key: 'sharda', name: 'Sharda Hospital' },
  { key: 'rajagiri', name: 'Rajagiri Hospital' },
  { key: 'psri', name: 'PSRI Hospital' },
];

const svg = (className, viewBox) => ({ className, viewBox, 'aria-hidden': true, focusable: 'false' });

/* A plus sign in two colours. */
function Cross({ a, b, className = 'clogo__cross' }) {
  return (
    <svg {...svg(className, '0 0 24 24')}>
      <path d="M8.5 1h7v7.5H23v7h-7.5V23h-7v-7.5H1v-7h7.5Z" fill={a} />
      <path d="M8.5 15.5H1v-7h7.5V1h3.5v22H8.5Z" fill={b} />
    </svg>
  );
}

function LogoArt({ id }) {
  switch (id) {
    case 'medibuddy':
      return (
        <>
          <svg {...svg('clogo__mark', '0 0 26 22')}>
            <g fill="none" strokeWidth="2.6" strokeLinejoin="round">
              <path d="M9 2 16 11 9 20 2 11Z" stroke="#e5484d" />
              <path d="M17 2l7 9-7 9-7-9Z" stroke="#2a56c6" />
            </g>
          </svg>
          <span>
            <span className="clogo__medi">Medi</span>
            <span className="clogo__buddy">Buddy</span>
          </span>
        </>
      );
    case 'pathkind':
      return (
        <>
          <span className="clogo__pk-tile">
            <i />
          </span>
          <span className="clogo__stack">
            <b className="clogo__pathkind">
              Pathkind
              <span className="clogo__pk-bars" />
            </b>
            <small className="clogo__pathkind-sub">Labs</small>
          </span>
        </>
      );
    case 'oncquest':
      return (
        <span className="clogo__oncquest">
          <span className="clogo__oq-dots" />
          <span className="clogo__stack">
            <b>oncquest</b>
            <small>laboratories</small>
          </span>
        </span>
      );
    case 'drlal':
      return (
        <>
          <Cross a="#1fa463" b="#e5484d" />
          <span className="clogo__stack clogo__drlal">
            <b>Dr. B. Lal</b>
            <small>Clinical Laboratory</small>
          </span>
        </>
      );
    case 'sharda':
      return (
        <>
          <svg {...svg('clogo__mark clogo__mark--wide', '0 0 30 22')}>
            <path d="M2 8c6 0 9 4 12 12C16 10 22 4 29 3" fill="none" stroke="#f2a21f" strokeWidth="2.8" strokeLinecap="round" />
            <circle cx="15" cy="6" r="2.6" fill="#1fa463" />
          </svg>
          <span className="clogo__stack clogo__sharda">
            <b>Sharda</b>
            <b>Hospital</b>
          </span>
        </>
      );
    case 'rajagiri':
      return (
        <>
          <Cross a="#e5484d" b="#c8232c" />
          <span className="clogo__stack clogo__rajagiri">
            <b>Rajagiri</b>
            <b>Hospital</b>
          </span>
        </>
      );
    case 'psri':
      return (
        <>
          <span className="clogo__psri-mark">P</span>
          <span className="clogo__stack clogo__psri">
            <b>PSRI Hospital</b>
            <small>A multi speciality hospital</small>
          </span>
        </>
      );
    default:
      return null;
  }
}

export function ClientLogo({ logo }) {
  return (
    <>
      <span className="sr-only">{logo.name}</span>
      <span className={`clogo clogo--${logo.key}`} aria-hidden="true">
        <LogoArt id={logo.key} />
      </span>
    </>
  );
}
